import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaDataService } from 'src/app/shared/services/meta-data.service';

@Component({
  selector: 'app-next-races',
  templateUrl: './next-races.component.html',
  styleUrls: ['./next-races.component.scss']
})
export class NextRacesComponent implements OnInit {
  title = 'Next_Betting_Seo.title'
  page: 'all' | 'pmu';

  constructor(
    private router: Router,
    private metaDataService:MetaDataService
    ) { }

  ngOnInit(): void {
    this.page = this.router.url.split('/').pop() as 'all' | 'pmu';
    this.metaDataService.setMetadata(this.title,"Next_Races_Seo.description_content",'Next_Races_Seo.keywords_content');
  }




}
